(ns dre.components.user-menu.notifications.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.i18n.utils :refer [tr-later]]
   [dre.network :as-alias network]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :notifications)

;; -- Events

(rf/reg-event-fx
 ::fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:db (assoc db :state :loading)
   ::network/request [{:endpoint :app/notifications}
                      {:on-success [::success-fetch]
                       :on-failure [::failure-fetch]}]}))

(rf/reg-event-fx
 ::mark-read
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [uuid]]
  {:db (assoc db :state :loading)
   ::network/request [{:endpoint :app/notifications-mark-read}
                      {:body {:notification-uuids (flatten [uuid])}
                       :on-success [::success-fetch]
                       :on-failure [::failure-fetch]}]}))

(rf/reg-event-fx
 ::success-fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  {:db (-> db
           (assoc :notifications (:body response))
           (assoc :state :success))}))

(rf/reg-event-fx
 ::failure-fetch
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (-> db
           (assoc :state :failure)
           (assoc :notifications nil))
   :dispatch-n [[:dre.network/default-failure opts]]}))

(rf/reg-event-fx
 ::set-active-tab
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [active-tab]]
  {:db (-> db
           (assoc :active-tab active-tab))}))

;; -- Subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::active-tab
 :<- [::state]
 (fn [state [_ tab-items]]
   (get-in state [:active-tab] (first tab-items))))

(rf/reg-sub
 ::notifications
 :<- [::state]
 (fn [state _]
   (:notifications state)))

(rf/reg-sub
 ::unread
 :<- [::notifications]
 (fn [state _]
   (filter (comp not :read) state)))